import {
	ICreateWatch,
	IUpdateWatch,
	IGetPaginatedWatches,
	IWatchNotificationsData,
	IRestaurantAndroidWatchesMessagesData,
	IGetRestaurantAndroidWatchesMessages,
} from 'types';
import {
	serviceGetWatchInfo,
	serviceCreateWatch,
	serviceUpdateWatch,
	serviceGetPaginatedWatches,
	serviceDeleteWatch,
	servicePushWatchNotifications,
	serviceGetRestaurantAndroidWatchesMessages,
	serviceAssignRestaurantAndroidWatchesMessages,
} from 'services/api/watches';
import { createAppErrorMessage } from 'utils/helpers';

const getWatchInfo = async (watchID: string) => {
	try {
		const response = await serviceGetWatchInfo(watchID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const createWatch = async (data: ICreateWatch) => {
	try {
		await serviceCreateWatch(data);
	} catch (err) {
		throw err;
	}
};

const updateWatch = async (data: IUpdateWatch) => {
	try {
		await serviceUpdateWatch(data);
	} catch (err) {
		throw err;
	}
};

const getPaginatedWatches = async (args: IGetPaginatedWatches) => {
	try {
		const response = await serviceGetPaginatedWatches(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const deleteWatch = async (watchID: string) => {
	try {
		await serviceDeleteWatch(watchID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingWatch');
		throw new Error(errorMessage);
	}
};

const pushWatchNotifications = async ({
	serialNumber,
	data,
}: {
	serialNumber: string;
	data: IWatchNotificationsData;
}) => {
	try {
		await servicePushWatchNotifications({ serialNumber, data });
	} catch (err) {
		throw err;
	}
};

const getRestaurantAndroidWatchesMessages = async (
	restaurantID: string,
): Promise<IGetRestaurantAndroidWatchesMessages> => {
	try {
		const response = await serviceGetRestaurantAndroidWatchesMessages(restaurantID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const assignRestaurantAndroidWatchesMessages = async ({
	restaurantID,
	data,
}: {
	restaurantID: string;
	data: IRestaurantAndroidWatchesMessagesData;
}) => {
	try {
		await serviceAssignRestaurantAndroidWatchesMessages({ restaurantID, data });
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorAssigningAndroidWatchesMessages');
		throw new Error(errorMessage);
	}
};

export {
	getWatchInfo,
	createWatch,
	updateWatch,
	getPaginatedWatches,
	deleteWatch,
	pushWatchNotifications,
	getRestaurantAndroidWatchesMessages,
	assignRestaurantAndroidWatchesMessages,
};
